import { DatasetPlaceholder } from "~/pages/manifold-nextgen/components/datasets/DatasetPlaceholder";

export const DatasetOverview = () => <DatasetPlaceholder label="Overview" />;
